import { EMPTY_STRING } from '@e-socna/empty';

export const hexToRgb = (hex: string): [number, number, number] => {
  const clean = hex.replace('#', EMPTY_STRING);
  const full =
    clean.length === 3
      ? clean
          .split(EMPTY_STRING)
          .map((c) => c + c)
          .join(EMPTY_STRING)
      : clean;
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
};
